import React, { Component } from 'react'
import Section from '../Section'
import BubbleTitle from '../BubbleTitle'
import ArrowLink from '../ArrowLink'
import MultiTextBoxes from './MultiTextBoxes'
import MultiTextList from './MultiTextList'
import MultiTextParagraphs from './MultiTextParagraphs'

export default class MultiText extends Component {
  render() {
    const { display } = this.props
    const data = [
      {
        text: this.props.text1,
        title: this.props.title1,
        icon: this.props.icon1,
      },
      {
        text: this.props.text2,
        title: this.props.title2,
        icon: this.props.icon2,
      },
      {
        text: this.props.text3,
        title: this.props.title3,
        icon: this.props.icon3,
      },
      {
        text: this.props.text4,
        title: this.props.title4,
        icon: this.props.icon4,
      },
      {
        text: this.props.text5,
        title: this.props.title5,
        icon: this.props.icon5,
      },
      {
        text: this.props.text6,
        title: this.props.title6,
        icon: this.props.icon6,
      },
      {
        text: this.props.text7,
        title: this.props.title7,
        icon: this.props.icon7,
      },
      {
        text: this.props.text8,
        title: this.props.title8,
        icon: this.props.icon8,
      },
      {
        text: this.props.text9,
        title: this.props.title9,
        icon: this.props.icon9,
      },
      {
        text: this.props.text10,
        title: this.props.title10,
        icon: this.props.icon10,
      },
    ]

    return (
      <Section
        color={this.props.color}
        fullHeight={this.props.fullHeight}
        paddingTop={this.props.paddingTop}
        paddingBottom={this.props.paddingBottom}
      >
        <BubbleTitle title={this.props.title} text={this.props.text} color={this.props.color} />
        {display === 'boxes' && <MultiTextBoxes data={data} columns={this.props.columns} />}
        {display === 'list' && <MultiTextList data={data} />}
        {display === 'paragraphs' && (
          <MultiTextParagraphs data={data} columns={this.props.columns} />
        )}
        {this.props.linkText && this.props.linkPath && (
          <ArrowLink text={this.props.linkText} path={this.props.linkPath} />
        )}
      </Section>
    )
  }
}

// <Markdown text={ this.props.text } />



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/MultiText/MultiText.jsx